import { render, staticRenderFns } from "./FileImageIcon.vue?vue&type=template&id=13cac64a"
import script from "./FileImageIcon.vue?vue&type=script&lang=js"
export * from "./FileImageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports